import ClinicalAnnotationsBarChart from 'components/ClinicalAnnotation/BarChart';
import Loading from 'components/Loading';
import KyError from 'components/errors/KyError';
import {useGet} from 'helpers/KyHooks';

export default function SummaryAnnotationGraph({className}) {
  const {response, error} = useGet('site/clinicalAnnotations/overview', {cacheResponse: true});
  
  let content = <Loading />;
  if (error) {
    content = <KyError kyError={error} />;
  } else if (response) {
    content = <ClinicalAnnotationsBarChart pgxLevels={response?.data} className="figure--floatRight" />;
  }
  
  return content;
}
